import { render, staticRenderFns } from "./BulkLabelExportNotification.vue?vue&type=template&id=bb771316"
import script from "./BulkLabelExportNotification.vue?vue&type=script&lang=js"
export * from "./BulkLabelExportNotification.vue?vue&type=script&lang=js"
import style0 from "./BulkLabelExportNotification.vue?vue&type=style&index=0&id=bb771316&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports